import React from 'react';
import Icon from '../Icon/Icon';
import './StripeTrustButtonInner.scss';

/**
 * Shared “trust” row: Apple Pay, Google Pay, title + lock + App Store / Google Play badge, Visa, Mastercard.
 * Used on contribute CTA and purchase CTA.
 */
function StripeTrustButtonInner({
	centerTitle = 'PURCHASE',
	loading = false,
	loadingLabel = 'Processing…',
	variant = 'solid',
	className = '',
}) {
	const outline = variant === 'outline';
	const displayTitle = loading ? loadingLabel : centerTitle;
	const lockColor = outline ? '#FF3232' : 'white';

	return (
		<div
			className={`stripe-trust-button-inner${outline ? ' stripe-trust-button-inner--outline' : ''}${className ? ` ${className}` : ''}`.trim()}
		>
			<div className="d-flex f-row jcsa aic w-100">
				<div className="d-flex f-row gap-8 aisb jcc">
					<div className="d-flex f-row gap-8">
						<div className="payment-icons p-4">
							<Icon alias="apple_pay" width={24} height={11} />
						</div>
						<div className="payment-icons p-4">
							<Icon alias="google_pay" width={24} height={11} />
						</div>
					</div>
				</div>
				<div className="stripe-trust-button-inner__center">
					{displayTitle}
					<div className="d-flex f-row gap-4 aisa jcc stripe-trust-button-inner__trust-row">
						<Icon alias="secured_lock" width={12} height={14} color={lockColor} />
						<div
							className="stripe-trust-button-inner__store-badge"
							aria-label="App Store and Google Play"
						>
							<Icon alias="powered_by_stripe" width={68} height={14} />
						</div>
					</div>
				</div>
				<div className="d-flex f-row gap-8 aisb jcc">
					<div className="payment-icons p-4">
						<Icon alias="visa" width={25} height={8} />
					</div>
					<div className="payment-icons p-4">
						<Icon alias="mastercard" width={25} height={8} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default StripeTrustButtonInner;
